// STDominicana Data File
// Pattern based on std.js structure

const data = {
  // Brand Information
  logo: "/assets/stdominicana/images/logo.png",
  title: "Soluciones Térmicas Dominicana",
  description: "Soluciones en aislamiento térmico para la industria",

  // Navigation Menu
  navigation: [
    {
      label: "¿Quiénes Somos?",
      url: "/quienes-somos",
      slug: "about"
    },
    {
      label: "Trabajos realizados",
      url: "/trabajos-realizados",
      slug: "projects"
    },
    {
      label: "Contactenos",
      url: "/contactenos",
      slug: "contact"
    }
  ],

  // Hero Section
  hero: {
    title: "Soluciones en aislamiento térmico para la industria",
    legend: "Proveemos asesoría sin costo alguno, para solucionar todas las necesidades que presenta la Industria en el área de Aislamiento Térmico.",
    subtitle: "HONESTIDAD, CUMPLIMIENTO Y PUNTUALIDAD ES LO QUE NOS CARACTERIZA.",
    backgroundImage: "/assets/stdominicana/images/hero-bg.jpg",
    cta: {
      text: "Contáctenos",
      url: "/contactenos"
    }
  },

  // About Section
  about: {
    title: "¿Quiénes Somos?",
    subtitle: "Nuestros Servicios",
    description: "En Soluciones Térmicas Dominicana nos enfocamos en brindar las alternativas más confiables que llevan a mantener los equipos industriales eficientizando su productividad al menor costo energético dependiendo de la cultura empresarial al mismo tiempo que la seguridad misma.",
    image: "/assets/stdominicana/images/about-image.jpg",
    cta: {
      text: "Más información",
      url: "/quienes-somos"
    }
  },

  // Services
  services: [
    {
      title: "Aislamiento Térmico Industrial",
      slug: "aislamiento-termico",
      description: "Soluciones profesionales de aislamiento térmico para equipos industriales, tuberías y tanques.",
      image: "/assets/stdominicana/images/services/aislamiento.jpg",
      icon: "thermal"
    },
    {
      title: "Mantenimiento Preventivo",
      slug: "mantenimiento",
      description: "Servicios de mantenimiento para garantizar el funcionamiento óptimo de sus sistemas térmicos.",
      image: "/assets/stdominicana/images/services/mantenimiento.jpg",
      icon: "maintenance"
    },
    {
      title: "Consultoría Técnica",
      slug: "consultoria",
      description: "Asesoría especializada para optimizar sus procesos industriales y reducir costos energéticos.",
      image: "/assets/stdominicana/images/services/consultoria.jpg",
      icon: "consulting"
    }
  ],

  // Features/Benefits
  features: [
    {
      title: "Experiencia Comprobada",
      description: "Más de 10 años brindando soluciones térmicas de calidad en República Dominicana",
      icon: "experience"
    },
    {
      title: "Equipo Certificado",
      description: "Profesionales capacitados y certificados en aislamiento térmico industrial",
      icon: "certified"
    },
    {
      title: "Materiales de Calidad",
      description: "Utilizamos materiales de primera calidad que garantizan durabilidad",
      icon: "quality"
    },
    {
      title: "Soporte Técnico",
      description: "Atención al cliente y soporte técnico disponible",
      icon: "support"
    }
  ],

  // Testimonials
  testimonials: [
    {
      name: "Carlos Rodríguez",
      company: "Industrias del Caribe S.A.",
      position: "Gerente de Operaciones",
      text: "Excelente servicio, lograron reducir nuestros costos energéticos en un 30%. Muy profesionales.",
      image: "/assets/stdominicana/images/testimonials/client-1.jpg",
      rating: 5
    },
    {
      name: "María González",
      company: "Manufacturera Dominicana",
      position: "Directora de Planta",
      text: "El equipo de Soluciones Térmicas fue muy profesional. El trabajo quedó impecable.",
      image: "/assets/stdominicana/images/testimonials/client-2.jpg",
      rating: 5
    }
  ],

  // Clients/Partners (logos)
  clients: [
    {
      name: "Cliente 1",
      logo: "/assets/stdominicana/images/clients/client-1.png"
    },
    {
      name: "Cliente 2",
      logo: "/assets/stdominicana/images/clients/client-2.png"
    },
    {
      name: "Cliente 3",
      logo: "/assets/stdominicana/images/clients/client-3.png"
    },
    {
      name: "Cliente 4",
      logo: "/assets/stdominicana/images/clients/client-4.png"
    }
  ],

  // Project Gallery
  projects: [
    {
      title: "Aislamiento Térmico Industrial",
      category: "Industrial",
      image: "/assets/stdominicana/images/projects/project-1.jpg",
      description: "Proyecto de aislamiento térmico para planta industrial"
    },
    {
      title: "Sistema de Tuberías",
      category: "Tuberías",
      image: "/assets/stdominicana/images/projects/project-2.jpg",
      description: "Instalación de aislamiento en sistema de tuberías"
    }
  ],

  // Contact Information
  contact: {
    address: "Calle Principal #123\nSanto Domingo, DN\nRepública Dominicana",
    phone: "809-555-5555",
    whatsapp: "829-555-5555",
    email: "info@stdominicana.com",
    social: {
      facebook: "https://facebook.com/stdominicana",
      instagram: "https://instagram.com/stdominicana",
      linkedin: "https://linkedin.com/company/stdominicana",
      youtube: ""
    }
  },

  // Call to Action Section
  cta: {
    title: "Contáctanos para recibir una cotización gratuita",
    subtitle: "Estamos listos para ayudarte con tus proyectos de aislamiento térmico industrial",
    backgroundImage: "/assets/stdominicana/images/cta-bg.jpg",
    button: {
      text: "Solicita Cotización",
      url: "/contactenos"
    }
  },

  // SEO & Meta
  seo: {
    keywords: "aislamiento térmico, soluciones industriales, mantenimiento industrial, República Dominicana, Santo Domingo",
    ogImage: "/assets/stdominicana/images/og-image.jpg"
  }
};

export default data;
